import React, { useState, useEffect } from "react";
import axios from "axios";
import CommonHeader from "../Common Header/CommonHeader";
import { Link } from "react-router-dom";
import "./news.css";

const NewsAndEvents = () => {
  const [newsData, setNewsData] = useState(null);

  // Fetch data when the component mounts
  useEffect(() => {
    gettingData();
  }, []);

  const gettingData = async () => {
    try {
      const response = await axios.get("/newsEvents.php");
      if (response?.status === 200) {
        const uniqueData = response.data.reduce((acc, current) => {
          const isExisting = acc.some(
            (item) =>
              item.title.trim().toLowerCase() ===
                current.title.trim().toLowerCase() &&
              item.event_date === current.event_date
          );
          if (!isExisting) acc.push(current);
          return acc;
        }, []);
        setNewsData(uniqueData);
      }
    } catch (error) {
      setNewsData([]);
      console.error("Error fetching data:", error);
    }
  };

  // Function to extract YouTube Video ID and generate embed URL
  const getYouTubeEmbedURL = (url) => {
    const youtubePattern =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/?|\S*?[?&]v=|(?:youtube\.com\/)?(?:v|e(?:mbed)?\/))(\S{11})(?=\?|$)|youtu\.be\/(\S{11}))/;
    const match = url.match(youtubePattern);
    if (match && (match[1] || match[2])) {
      const videoId = match[1] || match[2];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return null; // Return null if the URL is not a valid YouTube link
  };

  const renderContent = (content) => {
    return content
      .split("\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>);
  };

  // If news data is still being fetched, show loading message
  if (newsData === null) {
    return <h2>Loading....</h2>;
  }

  return (
    <>
      <CommonHeader heading={"Newsletters"} />
      <div className="container">
        <section className="news-box top-margin">
          <div className="container">
            <div className="row">
              {newsData.length > 0 ? (
                newsData.map((obj, ind) => (
                  <div className="col-lg-4 col-md-4 col-sm-12" key={ind}>
                    <div className="newsBox">
                      <div className="thumbnail">
                        {/* Image or video handling */}
                        {obj.images && obj.images.length > 0 ? (
                          <figure>
                            <img
                              src={`${axios.defaults.baseURL}/Images/${obj.images[0]}`}
                              alt="Event"
                              width="300"
                              height="200"
                              className="imageShadow"
                            />
                          </figure>
                        ) : obj.video_path ? (
                          // Check if the video_path is a valid YouTube URL and extract embed URL
                          getYouTubeEmbedURL(obj.video_path) ? (
                            <figure>
                              <iframe
                                width="300"
                                height="200"
                                src={getYouTubeEmbedURL(obj.video_path)}
                                frameBorder="0"
                                allowFullScreen
                                title={obj.title}
                              />
                            </figure>
                          ) : (
                            <div>No valid YouTube video found</div>
                          )
                        ) : (
                          <div>No image or video found</div>
                        )}
                        <div className="caption maxheight2">
                          <div className="box_inner">
                            <div className="box">
                              <p className="title">
                                <h3>{obj.title}</h3>
                              </p>
                              <p style={{ fontSize: "1.5rem" }}>
                                {obj.description
                                  .split(" ")
                                  .slice(0, 30)
                                  .join(" ")}
                              </p>
                              <p>
                                <Link to={`/aboutnewsevents/${obj.id}`}>
                                  <em>More...</em>
                                </Link>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <span>No news or events found.</span>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default NewsAndEvents;
